import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {Content, DateTime, Header, Keyboard, NavController, NavParams, Platform} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {UsuarioMenuPage} from "../usuario-menu/usuario-menu";
import {HotspotService} from "../../../providers/hotspot-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";
import {
    ENUM,
    TAction,
    TBrandedTipo,
    TProdutoTipo,
    TFinanceSide,
    TFinanceView,
    TFinanceDate,
    TGaleriaModo,
    TGaleriaTipo,
    THotspotFlag,
    TProfileTeam,
    TPrecifyMenu,
    TProdutoView,
    TProfileSexe,
    TUsuarioRole,
    TVersionBeta,
    TConsumoCalc,
    TGeradorView,
    TProfileAlma,
    TEstoqueView,
    TMonitorUnir,
    TMonitorDoby,
    TPrinterBind,
    TPaymentStep,
} from "../../../app/enum";
import {GaleriaMenuPage} from "../galeria-menu/galeria-menu";
import {SupportMenuPage} from "../support-menu/support-menu";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ShowtimePage} from "../../show/showtime/showtime";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";
import {BrandedMenuPage} from "../branded-menu/branded-menu";
import {FinanceMenuPage} from "../finance-menu/finance-menu";
import {StorageService} from "../../../providers/storage-service";
import {ContabyMenuPage} from "../contaby-menu/contaby-menu";
import {ProdutoMenuPage} from "../produto-menu/produto-menu";
import {MessageService} from "../../../providers/message-service";
import {SettingMenuPage, TWorkdayShut} from "../setting-menu/setting-menu";
import {PaybookFindPage} from "../paybook-find/paybook-find";
import {GateweyMenuPage} from "../gatewey-menu/gatewey-menu";
import {HotspotMarkPage} from "../hotspot-mark/hotspot-mark";
import {WebstorOpenPage} from "../webstor-open/webstor-open";
//import {WarningMenuPage} from "../warning-menu/warning-menu";
import {MonitorDeskPage} from "../monitor-desk/monitor-desk";
import {ConviteMenuPage} from '../convite-menu/convite-menu';
import {WorkdayCodePage} from '../workday-code/workday-code';
import {PrivacyMenuPage} from '../privacy-menu/privacy-menu';
import {ParcelaMenuPage} from '../parcela-menu/parcela-menu';
import {EntrakiOpenPage} from '../entraki-open/entraki-open';


@Component({
    selector: 'page-hotspot-menu',
    templateUrl: 'hotspot-menu.html',
    providers: [WebstorService, HotspotService, HotspotRepository, ProfileRepository, ProfileService]
})
export class HotspotMenuPage {

    ENUM: any = ENUM;
    config: any;


    //Hotspot - etapa 0 - LOAD
    TBrandedTipo: any = TBrandedTipo;
    TProdutoTipo: any = TProdutoTipo;
    THotspotFlag: any = THotspotFlag;
    TUsuarioRole: any = TUsuarioRole;
    TProfileSexe: any = TProfileSexe;


    logado: any;
    rootile: any;
    pulsed: boolean;

    etapa: number;
    userset: any;

    workday: any;
    branded: any;
    rootspot: any;
    copyspot: any;

    forcedView: boolean;
    searchTerm: string = '';

    hotspotDedo: boolean = true;

    @ViewChild(Header) header: Header;
    @ViewChild(Content) content: Content;
    @ViewChild(DateTime) iondate: DateTime;
    @ViewChild('pulsedItem') pulsedElement: ElementRef;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                private keyboard: Keyboard,
                public platform: Platform,
                public util: Util, public storageService: StorageService,
                public messageService: MessageService,
                public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository,
                public webstorService: WebstorService) {

        this.pulsed = false;
        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        let hotspotID = this.navParams.get('hotspotID');
        this.branded = this.navParams.get('branded');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Hotspot Menu', '/hotspot-menu');

        if (hotspotID)                  this.hotspotLoad(hotspotID);
        if (!hotspotID && this.branded) this.hotspotInit(this.branded);

        // Vem da BrandedMenuPage - Criar novo Hotspot
        if (!hotspotID && !this.userset) {
            this.userset = this.hotspotRepository.usuarioFake(0, this.rootile.Profile, null);
        }

    }

    getTitle(): string {

        if (!this.copyspot) return 'Hotspot';

        if (this.etapa == 0) return this.copyspot.Hotspots[0].Branded.BrandedShow;

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        let webstorNick = 'ADM'; //this.branded.BrandedNick;
        this.messageService.get('webstor.nick').next(webstorNick);

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    navctrlBool(platform) {
    
        let platformBool =  this.platform.is(platform);

        return (platformBool && this.util.nativeApp());

    }

    controlPush(page, object, options?) {

        let pushControl = false; //this.dataService.get('PUSH.CONTROL');
        if ( pushControl) this.navCtrl.push(page, object, options);
        if (!pushControl) this.util.navActive().push(page, object, options);

    }

    ellzitoOlho() {

        return (this.rootile.Profile.ProfileZito && !this.userset.FlagTeam);
      //return (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkManager && !this.userset.FlagTeam);

    }

    ellzitoTurn() {

        this.userset.FlagZito = (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkManager && this.rootile.Profile.ProfileZito);
        this.userset.FlagTeam = (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkManager);
        this.userset.FlagPreside = (this.userset.FlagPreside || this.userset.FlagTeam);
        this.userset.FlagDiretor = (this.userset.FlagDiretor || this.userset.FlagTeam);
        this.userset.FlagGerente = (this.userset.FlagGerente || this.userset.FlagTeam);

    }

    escutarSave() {

        let onSpot = () => {
            (window as any).handappMainInstance.escutarSave('Hotspot', this.copyspot.Hotspots[0].HotspotID);
        }

        let onNoro = () => {
            let object = {etapa: 9, hotspot: null, spotdayID: 0, paybook: null, paybookTipo: null, paybookModo: null};
            this.util.modalopen(EntrakiOpenPage, 'alto', false, object).subscribe();
        }

        let buttons: Array<any> = [];
        buttons.push({text: 'Hotspot',   handler: () => onSpot()});
        buttons.push({text: 'Comanda',   handler: () => onNoro()});
        this.util.sheetOpen(buttons, 'NFC');

    }

    brandedLogo() {

        let zito = this.userset.FlagZito;
        let team = this.userset.FlagTeam;
        if (!team && !this.util.nativeApp()) return;

        let onLogo = () => {
            let object = {etapa: 1, rootile: this.rootile, brandeds: [this.copyspot.Hotspots[0].Branded], brended: null, negocios: null};
            this.controlPush(BrandedMenuPage, object);
        }

        let buttons: Array<any> = [];
                  buttons.push({text: 'NFC',   handler: () => this.escutarSave()});
        if (zito) buttons.push({text: 'Brand', handler: () => onLogo()});
        this.util.sheetOpen(buttons, 'CONSUMO');

    }

    hotspotLoad(hotspotID) {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acSpot, hotspotID, this.rootile.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!data.Hotspots || !data.Hotspots.length) return;

                    this.rootspot = data;
                    this.copyspot = this.util.deepCopy(data);

                    //#GAMB - Vem [Parcelas] da Bridge
                    this.copyspot.Parcelas = null;
                    this.copyspot.Usuarios.forEach(US => US.UsuarioFatu = (this.copyspot.Hotspots[0].HotspotMail == (US.UsuarioPara || US.Profile.ContatoMail)));

                    this.userset = this.hotspotRepository.usuarioFlag(this.copyspot.Usuarios, this.rootile.Profile.ProfileID, this.rootile.Profile.ProfileTeam);

                    if (!this.userset && !this.rootile.Profile.ProfileTeam) {
                        this.util.toastSimply('Acesso negado!');
                        this.dismiss();
                        return;
                    }

                    if (!this.userset && this.rootile.Profile.ProfileTeam) {
                        this.userset = this.hotspotRepository.usuarioFake(this.copyspot.Hotspots[0].HotspotID, this.rootile.Profile, null);
                    }

                    //EXCLUIR - Qdo nao tem mais Lorean
                    this.userset.SpotOlha = (this.copyspot.Hotspots[0].HotspotID == this.config.kairos.HotspotID);
                    this.userset.SpotMigo = (this.copyspot.Hotspots[0].Partner && this.copyspot.Hotspots[0].HotspotID == this.copyspot.Hotspots[0].Partner.HotspotID);
                    this.userset.Userlink = !!(data.Brandeds.filter(br => (br.BrandedTipo == TBrandedTipo.btFranquia && br.HotspotID == this.copyspot.Hotspots[0].HotspotID)).length);
                    
                    this.pulsePressed();


                    if (data.Hotspots[0].Contrato && this.userset.FlagTeam) {
                        this.rootspot.Parcelas = [];
                        this.copyspot.Parcelas = [];

                        let params = '&ContratoID=' + data.Hotspots[0].Contrato.ContratoID;
                        this.util.monitorDesk(false, 'DESK-Parcela', this.config.kairos.HotspotID, params, TAction.acSpot)
                            .subscribe(
                                desk => {
                                    this.rootspot.Parcelas = desk.Parcelas;
                                    this.copyspot.Parcelas = this.util.deepCopy(desk.Parcelas);
                                },
                                //erro => this.util.alertResult(erro)
                            );
                    }

                    //#MOVIE
                    // if (0 == 0) {
                    //     this.util.modalopen(WarningMenuPage, 'alto', false, {etapa: 1}, {animate: false}).subscribe();
                    // }



                    //#HELP - Rola a tela toda vez que entrar até esconder o logo!
                    if (this.util.nativeApp() || this.util.browserApp()) {
                        setTimeout(() => {
                            let bool = (this.content.getScrollElement().scrollTop == 0 && !this.keyboard.isOpen());
                            if (bool) this.content.scrollTo(0, 275, 100); //(0, 260, 1000);
                        }, 100);//3000);
                    }

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    hotspotInit(branded) {

        let a = branded.Negocio.AmbientID;
        
        let dateone = this.util.diaFirst(new Date());
        let datenew = this.util.dateToStr(dateone);
        let unidade = {HotspotID: 0, UnidadeID: 0, UnidadeNome: '', UnidadeOpen: datenew, UnidadeShut: '', Branded: branded};
        let profile = {ProfileID: 0, ProfileShow: null, ProfileRnid: null};
        let ambient = {AmbientID: a, AmbientNome: '', AmbientIcon: ''};
        let empresa = {EmpresaID: 0, Profile: profile};
        let recinto = {RecintoID: 0, ProfileID: 0, Ambient: ambient, RecintoMenu: TPrecifyMenu.pcNormal, RecintoGorj: 0, RecintoObar: 6, RecintoSeat: 0, RecintoRoom: null};
        let project = {ProjetoID: 1005, ProjetoNome: 'Lorean', ProjetoIcon: 'b-icon-cup'};
        let setting = {HotspotID: 0, 
                       SettingLook: true,
                       SettingCego: true,
                       SettingCent: true, 
                       SettingDedo: 50,
                       SettingGorj: 0, 
                       SettingShut: TWorkdayShut.wsEmissor, 
                       SettingBars: 0,
                       SettingPinu: true,
                       SettingCard: true,
                       SettingSale: false,
                       SettingPedy: false,
                       SettingSair: true,
                       SettingPrey: false,
                       SettingAlma: TProfileAlma.paNão,
                       SettingTeto: 0,
                       SettingLote: 0,
                       SettingMesa: false,
                       SettingCoin: 0,
                       SettingBind: TPrinterBind.ppLancado,
                       SettingTela: 20,
                       SettingKode: false,
                       SettingMeio: 0,
                       SettingHalf: 5,
                       SettingDoby: TMonitorDoby.dyLancamento,
                       SettingUnir: TMonitorUnir.muMaior,
                       SettingShot: 0,
                       SettingDose: 0,
                       SettingStok: TEstoqueView.mlFracao, 
                       SettingClub: 0,
                       SettingMail: '',
                      };

        let hotspot = {
            HotspotID: 0,
            HotspotFlag: THotspotFlag.hfHotspotAberto,
            HotspotQtde: 0,
            HotspotBeta: TVersionBeta.vbRelease,
            HotspotRoxo: true,
            HotspotTurn: 6,
            HotspotParc: 0,
            HotspotPiso: 0,
            HotspotLota: 1,
            HotspotFixo: false,
            HotspotCode: '',
            HotspotKode: 0,
            HotspotWork: 0,
            HotspotSync: 0,
            HotspotOkay: 0,
            HotspotHoip: '',
            HotspotAuth: '',
            HotspotSpot: '',
            HotspotHash: '',
            HotspotSoft: '',
            HotspotFirm: '',
            HotspotWarn: '',
            HotspotMail: '',
            Setting: setting,
            Project: project,
            Gatewey: this.config.gatewey,
            Branded: branded,
            Empresas: [empresa],
            Recintos: [recinto],
        };
        this.rootspot = {Hotspots: [hotspot], Unidades: [unidade], Usuarios: [], Meritums: []};
        this.copyspot = this.util.deepCopy(this.rootspot);

        //Flagueia as permissoes retornando o usuario logado
        this.userset = this.hotspotRepository.usuarioFlag(this.copyspot.Usuarios, this.rootile.Profile.ProfileID);

    }

    hotspotCria() {

        let json = this.copyspot;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.webstor(TAction.acSpot, 0, 0, '', false, false, '', json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.hotspotLoad(data.Codigo),
                erro => this.util.alertResult(erro)
            );

    }

    pulsePressed() {

        if (!this.pulsedElement) return;

        let handle;
        handle = setInterval(() => {

            let heightComp = this.pulsedElement.nativeElement.getBoundingClientRect().top;
            let heightHead = this.header.getNativeElement().clientHeight;
            let heightWind = window.innerHeight;
            this.pulsed = (heightComp > heightHead && heightComp < heightWind);

            if (this.pulsed) {
                clearInterval(handle);
                setTimeout(() => this.pulsed = false, 2000);
            }

        }, 1000);

    }



    /** ************************************************ HOTSPOT ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    brandedShow() {

        let branded = this.copyspot.Hotspots[0].Branded;
        let unidade = this.copyspot.Unidades[0];
        branded.BrandedShow = (branded.BrandedNome + ' ' + unidade.UnidadeNome);

    }

    empresaFind() {

        let line = this.copyspot.Hotspots[0].Empresas[0].Profile;
        let cnpj = this.util.validaCNPJ(line.ProfileRnid);

        if (!cnpj) {
            line.ProfileBool = false;
            return;
        }

        if (line.ProfileBool) return;
        line.ProfileBool = true;

        let rnid = line.ProfileRnid;
        let ghosterID = this.copyspot.Hotspots[0].Branded.BrandedID;
        this.profileRepository.profileFind(rnid, 'CNPJ', ProfileMenuPage, ghosterID, true)
            .subscribe(
                lino => {
                    this.copyspot.Hotspots[0].Empresas[0].Profile = lino;
                    this.copyspot.Hotspots[0].EmpresaID = lino.ProfileID;
                });

    }

    profileMenu(line) {

        let object = {profileSpot: true, profileID: line.ProfileID, rootile: null, etapa: 1};
        this.util.modalopen(ProfileMenuPage, 'alto', false, object).subscribe();

    }

    profilePage(profile) {

        let object = {profileID: profile.ProfileID};
        this.controlPush(ProfilePagePage, object);

    }



    /** ************************************************ HOTSPOT ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    settingSpot(tela: 'setting' | 'initing') {

        let etapa = 0;
        if (tela == 'initing') etapa = 1;
        if (tela == 'setting') etapa = 0;

        let open;
        if (tela == 'initing') open = 'quad';
        if (tela == 'setting') open = 'push';

        let object = {etapa: etapa, rootile: this.rootile, rootspot: this.rootspot, copyspot: this.copyspot, userset: this.userset};
        if (open == 'push') this.controlPush(SettingMenuPage, object);
        if (open == 'quad') this.util.modalopen(SettingMenuPage, 'quad', true, object).subscribe();

    }

    workdayFlash() {

        let object = {etapa: 2, rootile: this.rootile, rootspot: this.rootspot, copyspot: this.copyspot, userset: this.userset};
        this.util.modalopen(WorkdayCodePage, 'alto', false, object).subscribe();

    }

    hotspotFlug(flug: 'barra' | 'text' | 'work') {

        let status  = (this.copyspot ? this.copyspot.Hotspots[0] : this.branded).HotspotFlag;
        let branded = (this.copyspot ? this.copyspot.Hotspots[0].Branded : this.branded);

        if (flug == 'work') {
            let array = [THotspotFlag.hfHotspotAberto, THotspotFlag.hfHotspotLimitado];
            return (this.copyspot && array.indexOf(status) >= 0) || this.forcedView;
        }

        if (flug == 'text') {
            if (status == THotspotFlag.hfHotspotAberto) return branded.Negocio.NegocioName + ' - ' + branded.Negocio.NegocioNome;
            if (status != THotspotFlag.hfHotspotAberto) return 'Hotspot ' + THotspotFlag[status].slice(9, 99);
        }

        if (flug == 'barra') {
            if (status == THotspotFlag.hfHotspotNenhum)    return 'CorMilk';
            if (status == THotspotFlag.hfHotspotTrial)     return 'CorMato';
            if (status == THotspotFlag.hfHotspotAberto)    return 'CorDash';
            if (status == THotspotFlag.hfHotspotLimitado)  return 'CorGold';
            if (status == THotspotFlag.hfHotspotBloqueado) return 'CorFogo';
            if (status == THotspotFlag.hfHotspotSuspenso)  return 'CorVerm';
            if (status == THotspotFlag.hfHotspotFechado)   return 'CorMenu';
        }

    }

    paybookFind() {

        let searchTerm = this.searchTerm;
        let searchSize = this.searchTerm.length;
        if (searchSize < 4) {
            if (searchSize) this.util.toastSimply('Mínimo de 4 caracteres.');
            return;
        }

        this.keyboard.close();
        this.keyboard.onClose(() => {

            this.searchTerm = '';

            let object = {etapa: 0, hotspotID: this.copyspot.Hotspots[0].HotspotID, geradorID: 0, profileID: 0, rootspot: this.rootspot, copyspot: this.copyspot, userset: this.userset, searchTerm: searchTerm};
            this.controlPush(PaybookFindPage, object);

        });

    }

    extratoMenu() {

        let hotspot = this.copyspot.Hotspots[0];
        let gateway = (this.userset.FlagZito || this.userset.FlagCoin) && hotspot.HotspotID == hotspot.Gatewey.HotspotID ? hotspot.Gatewey.GateweyNome : '';

        /** OPEN **/
        let buttons: Array<any> = [];
        if ( gateway) buttons.push({text: gateway,   handler: () => this.gateweyMenu(), cssClass: this.util.sheetClass(true, true, 'lime') + ' shadow-lorean-dark'});
        if (!gateway) buttons.push({text: 'Resgate', handler: () => this.resgateMenu(), cssClass: this.util.sheetClass(true, true, 'lime') + ' shadow-lorean-dark'});
                      buttons.push({text: 'Conta',   handler: () => this.accountLoad()});
                      buttons.push({text: 'Caixa',   handler: () => this.cashierPush()});
        this.util.sheetOpen(buttons, 'EXTRATO');

    }

    accountLoad() {

        let onLoad = (data) => {
            if (data) this.copyspot.Accounts = data.Accounts;

            /** OPEN **/
            let buttons: Array<any> = [];
            let array = this.copyspot.Accounts;
            array.forEach(AC => buttons.push({text: AC.AccountNocc, handler: () => this.financePush(4, TFinanceSide.cdTodos, AC)}));
            this.util.sheetOpen(buttons, 'CONTA');
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.account(TAction.acSpot, 0, 0, this.copyspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro)
            );

    }



    /** MAINBOARD **/
    /** ********* **/

    hotviewMenu(etapa) {

        //Consumo
        if (etapa == 1) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Público',     handler: () => this.financePush(0, TFinanceSide.cdCredito)});
            buttons.push({text: 'Receita',     handler: () => this.financePush(1, TFinanceSide.cdCredito)});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Despesa',     handler: () => this.financePush(1, TFinanceSide.cdDebito), role: 'destructive'});
            this.util.sheetOpen(buttons, 'CONSUMO');
        }

        //Financeiro
        if (etapa == 2) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Recebido',  handler: () => this.financePush(etapa, TFinanceSide.cdCredito)});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Enviado',   handler: () => this.financePush(etapa, TFinanceSide.cdDebito), role: 'destructive'});
            if (this.userset.UsuarioDesp) buttons.push({text: 'Resultado', handler: () => this.financePush(etapa, TFinanceSide.cdTodos), cssClass: this.util.sheetClass(true, true, 'roxa') + ' shadow-lorean-lime'});
            this.util.sheetOpen(buttons, 'PAGAMENTO');
        }

        //Contrato
        if (etapa == 3) {
            let wallet = (this.copyspot.Hotspots[0].Partner && this.copyspot.Hotspots[0].HotspotID == this.copyspot.Hotspots[0].Partner.HotspotID);

            let buttons: Array<any> = [];
            buttons.push({text: 'Crédito',     handler: () => this.financePush(etapa, TFinanceSide.cdCredito)});
            buttons.push({text: 'Débito',      handler: () => this.financePush(etapa, TFinanceSide.cdDebito), role: 'destructive'});
            if (wallet) buttons.push({text: 'Wallet',      handler: () => this.partnerMenu()});
            this.util.sheetOpen(buttons, 'CONTRATO');
        }

        //Extrato
        if (etapa == 4) {
            this.financePush(etapa, TFinanceSide.cdTodos);
        }

    }

    cashierPush() {

    }

    financePush(etapa, financeSide, account?) {

        this.storageService.get('FINANCE-DATE').subscribe(financeDate => {
            this.storageService.get('FINANCE-DATA').subscribe(financeData => {
                this.storageService.get('FINANCE-VIEW').subscribe(financeView => {

                    let financeOlho = this.userset.FlagOlho;
                    let consumoCalc = TConsumoCalc.ccVenda;
                    let contratoView = TGeradorView.cvGanhoMrr;
                    financeView = (financeOlho ? (financeView ? financeView : TFinanceView.ceCash) : TFinanceView.ceCent);
                    financeData = (financeData ? financeData : this.util.dateToStr(null));
                    financeDate = (financeDate == null ? TFinanceDate.fdMes : financeDate);
                    
                    let object = {etapa: etapa, perfil: this.rootile, userset: this.userset, copyspot: this.copyspot, rootspot: this.rootspot, financeSide: financeSide, cashday: financeData, financeDate: financeDate, financeView: financeView, consumoCalc: consumoCalc, contratoView: contratoView, filtred: account};
                    this.controlPush(FinanceMenuPage, object);

                });
            });
        });

    }

    contabyPush() {

        this.storageService.get('FINANCE-DATE').subscribe(financeDate => {

            let cashday = this.util.dateToStr(null);
            let financeOlho = this.userset.FlagOlho;
            let financeView = (financeOlho ? TFinanceView.ceCash : TFinanceView.ceCent);
            financeDate = (financeDate == null ? TFinanceDate.fdMes : financeDate);

            let object = {etapa: 1, perfil: this.rootile, userset: this.userset, brandedID: 0, copyspot: this.copyspot, rootspot: this.rootspot, financeSide: TFinanceSide.cdCredito, cashday: cashday, financeDate: financeDate, financeView: financeView, filtred: null};
            this.controlPush(ContabyMenuPage, object);

        });

    }

    partnerMenu() {

        let object = {etapa: 2, rootile: this.rootile, partnerID: this.copyspot.Hotspots[0].HotspotID};
        this.controlPush(NegocioMenuPage, object);

    }

    gateweyMenu() {

        let object = {etapa: 0, hotspotID: 0, gatewey: this.copyspot.Hotspots[0].Gatewey};
        this.controlPush(GateweyMenuPage, object);

    }

    resgateMenu() {

        let cashday = this.util.dateToStr(null);

        let object = {etapa: 2, hotspotID: this.copyspot.Hotspots[0].HotspotID, gatewey: this.copyspot.Hotspots[0].Gatewey, financeDate: TFinanceDate.fdEra, paymentStep: TPaymentStep.psPrevisto, paymentTest: false, cashday: cashday};
        this.controlPush(GateweyMenuPage, object);

    }




    /** DASHBOARD **/
    /** ********* **/

    meritumHave(produtoTipo: TProdutoTipo) {

        return this.hotspotRepository.meritumArray(this.copyspot, produtoTipo, this.userset.FlagCard, this.userset.FlagSeal);

    }

    meritumText(meritum): string {

        let cardqtd = this.util.jsCount(meritum.BlendedArray, ['ProdutoCards', 'ProdutoID']);
        let sealqtd = this.util.jsCount(meritum.BlendedArray, ['ProdutoSeals', 'ProdutoID']);
        if (meritum.Branded.HotspotID != this.copyspot.Hotspots[0].HotspotID) sealqtd = 0;

        return (!cardqtd ? '' : cardqtd + ' cards') + (!sealqtd ? '' : (!cardqtd ? '' : ', ') + sealqtd + ' seals');

    }

    meritumView(meritum) {

        /** SHOW **/
        let onView = (produtoTipo, blended) => {
            let grouped = (meritum.Branded.BrandedTipo == TBrandedTipo.btGrupo);
            let allspot = (grouped ? this.userset.FlagDiretor : (meritum.Branded.HotspotID == this.copyspot.Hotspots[0].HotspotID));
            let indexHS = (allspot ? 0 : meritum.BrandedSpots.findIndex(hs => hs.HotspotID == this.copyspot.Hotspots[0].HotspotID));
            let indexBL = meritum.BlendedArray.findIndex(bl => bl.BlendedID == blended.BlendedID);
            let object = {etapa: 0, rootile: this.rootile, userhot: this.userset, meritums: [meritum], produtoTipo: produtoTipo, indexBL: indexBL, indexHS: indexHS, allspot: allspot};
            this.controlPush(MeritumMenuPage, object);
        };

        /** TWIN **/
        let onTwin = (produtoTipo, arrey?) => {

            if (arrey) meritum.bxTwin = arrey;

            /** OPEN **/
            let buttons: Array<any> = [];
            let boxnamed = (produtoTipo == TProdutoTipo.ptSeal ? 'ProdutoSeals' : 'ProdutoCards');
            let array = meritum.bxTwin.filter(BL => BL[boxnamed].length);
            array.forEach(BL => buttons.push({text: BL.BlendedNome, handler: () => onView(produtoTipo, BL)}));
            this.util.sheetOpen(buttons, 'BLEND');

        };

        /** LOAD **/
        let onLoad = (produtoTipo) => {

            if (meritum.bxTwin) {
                onTwin(produtoTipo, null);
                return;
            }

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.meritum(TAction.acSpot, meritum.MeritumID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => onTwin(produtoTipo, data.Meritums[0].BlendedArray),
                    erro => this.util.alertResult(erro)
                );

        };

        let sameSpot = (meritum.Branded.HotspotID == this.copyspot.Hotspots[0].HotspotID);
        let boolCard = this.userset.FlagCard;
        let boolSeal = this.userset.FlagSeal && sameSpot;

        let qtdeCard = this.util.jsCount(meritum.BlendedArray, ['ProdutoCards', 'ProdutoID']);
        let qtdeSeal = this.util.jsCount(meritum.BlendedArray, ['ProdutoSeals', 'ProdutoID']);

        /** OPEN **/
        let buttons: Array<any> = [];
        if (boolCard && qtdeCard) buttons.push({text: 'Card', handler: () => onLoad(TProdutoTipo.ptCard)});
        if (boolSeal && qtdeSeal) buttons.push({text: 'Seal', handler: () => onLoad(TProdutoTipo.ptSeal)});
        this.util.sheetOpen(buttons, 'MERITUM');

    }

    marketing() {

        let object = {etapa: 0, rootile: this.rootile, rootspot: this.rootspot, copyspot: this.copyspot, userset: this.userset};
        this.controlPush(HotspotMarkPage, object);

    }

    galeriaMenu() {

        let object = {
            copyspot: this.copyspot,
            eventoID: 0,
            homeb: true,
            etapa: 0,
            selected: 0,
            galerias: null,
            galeriaTipo: TGaleriaTipo.gtNenhum,
            galeriaModo: TGaleriaModo.gmNenhum,
        };
        this.controlPush(GaleriaMenuPage, object);

    }

    supportMenu() {

        let object = {etapa: 0, profile: null, hotspotID: this.copyspot.Hotspots[0].HotspotID, supports: null, selected: 0};
        this.controlPush(SupportMenuPage, object);

    }





    /** ITEMBOARD **/
    /** ********* **/

    parcelaMenu(teamview) {

        if (teamview && this.userset.FlagTeam) {
            this.forcedView = true;
            return;
        }

        let object = {etapa: 0, rootile: this.rootile, userset: this.userset, copyspot: this.copyspot, rootspot: this.rootspot};
        this.controlPush(ParcelaMenuPage, object);

    }

    parcelaDias(): number {

        let result = 0;
        this.copyspot.Parcelas.forEach(parcela => {
            let dias = this.util.dateDias(parcela.ParcelaData);
            if (dias > result) result = dias;
        });

        return result;

    }

    showtime() {

        this.controlPush(ShowtimePage, null, {animate: false});

        //Abrir camera...
        alert('Deletar essa funcao');

    }

    monitorOpen() {

        let object = {etapa: 5, devicerEdit: true, hotspotID: this.copyspot.Hotspots[0].HotspotID};
        this.util.modalopen(MonitorDeskPage, 'alto', false, object).subscribe();

    }

    precifyMenu() { 

        let lota = this.copyspot.Hotspots[0].HotspotLota;
        let team = this.userset.FlagTeam;
        let menu = this.copyspot.Hotspots[0].Recintos.filter(RE => RE.RecintoMenu > TPrecifyMenu.pcNormal).length > 0;

        let buttons: Array<any> = [];
        if (lota) buttons.push({text: 'Convite',     handler: () => this.precifyDoor()});
        if (team) buttons.push({text: 'Cardápio',    handler: () => this.precifyItem()});
        if (menu) buttons.push({text: 'Dispositivo', handler: () => this.monitorOpen()});
        this.util.sheetOpen(buttons, 'PREÇO');

    }

    precifyDoor() {

        let object = {etapa: 0, rootspot: this.rootspot, userset: this.userset};
        this.controlPush(ConviteMenuPage, object);

    }

    precifyItem() {
        
        let object = {etapa: 0, homeb: false, rootspot: this.rootspot, produtoFull: false, produtoView: TProdutoView.pdPrecify, precifyMenu: TPrecifyMenu.pcNormal};
        this.controlPush(ProdutoMenuPage, object);

    }

    estoqueMenu() {

        let object = {etapa: 0, homeb: false, rootspot: this.rootspot, produtoFull: false, produtoView: TProdutoView.pdEstoque, precifyMenu: TPrecifyMenu.pcDefault};
        this.controlPush(ProdutoMenuPage, object);

    }





    /** USERBOARD **/
    /** ********* **/

    hotspotPage(hotspotID, branded) {

        let object = {hotspotID: hotspotID, brandex: branded, tabmenu: false};
        this.util.navActive().push(WebsiteSpotPage, object);

    }

    workjobMenu() {

    }

    usuarioLixo(profileID, $event) {

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.usuario(TAction.acLixo, this.copyspot.Hotspots[0].HotspotID, profileID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        if (!$event) {
                            // Avisa para carregar os Hotspots que tem acesso novamente!
                            this.messageService.get('usuario.lixo').next({HotspotID: this.copyspot.Hotspots[0].HotspotID});
                            this.navCtrl.popToRoot();
                        }

                        if ($event) {
                            let index = this.copyspot.Usuarios.findIndex(US => US.Profile.ProfileID == profileID);
                            this.copyspot.Usuarios.splice(index, 1);
                        }
                    },
                    erro => this.util.alertResult(erro)
                );

        };

        if ($event) {
            $event.stopPropagation();
            onLixo()
            return;
        }

        let alerta = 'Você <b>perderá o acesso</b> ao Hotspot.';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Eu CONFIRMO', onLixo, false, true);

    }

    usuarioShow(usuario): boolean {

        if (!usuario) return true;
        
        let team = this.userset.FlagTeam;
        let role = (usuario.UsuarioRole > this.userset.UsuarioRole || this.userset.UsuarioRole == TUsuarioRole.urCEO);
        let none = (usuario.UsuarioRole == TUsuarioRole.urNenhum);
        return (none || team || role);

    }

    usuarioMenu(usuario, usernew: boolean = false) {

        //Manager não pode alterar executivo
        if (!this.usuarioShow(usuario)) return;

        let etapa = (usuario.UsuarioRole ? 0 : 1);
        let object = {etapa: etapa, rootile: this.rootile, usernew: usernew, userset: this.userset, usuario: usuario, rootspot: this.rootspot, copyspot: this.copyspot};
        this.controlPush(UsuarioMenuPage, object);

    }

    usuarioList() {
        
        let object = {etapa: 2, rootile: this.rootile, usernew: false, userset: this.userset, usuario: null, rootspot: this.rootspot, copyspot: this.copyspot};
        this.controlPush(UsuarioMenuPage, object);

    }

    usuarioFind() {

        //Finded Profile
        if (!this.util.validaCNPF(this.copyspot._documento)) return;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            let rnid = this.copyspot._documento;
            let ghosterID = this.copyspot.Hotspots[0].Branded.BrandedID;
            this.profileRepository.profileFind(rnid, 'CPF', ProfileMenuPage, ghosterID).subscribe(
                lino => {

                    this.copyspot._documento = '';

                    //Receita Federal                    
                    this.profileRepository.birthday(PrivacyMenuPage, true, lino, (this.userset || {}).FlagTeam).subscribe(data => {

                        //Perfil já esta adicionado, seleciona!
                        let userfnd = this.copyspot.Usuarios.filter(usuario => (usuario.Profile.ProfileID == lino.ProfileID && usuario.HotspotID == this.copyspot.Hotspots[0].HotspotID && this.copyspot.Hotspots[0].HotspotID > 0))[0];

                        //Perfil JÁ esta adicionado, mostra!
                        if (userfnd) this.usuarioMenu(userfnd);

                        //Perfil NAO esta adicionado, adiciona!
                        if (!userfnd) this.usuarioCria(lino);

                    });

                },
                erro => this.copyspot._documento = '');

        });

    }

    usuarioCria(profile) {

        let hotspotID = this.copyspot.Hotspots[0].HotspotID;
        let hotspotNovo = (this.copyspot.Hotspots[0].HotspotID == 0);

        let usuario = this.hotspotRepository.usuarioNull(hotspotID, profile, this.logado.Profile);

        //Hotspot SIM existe
        if (!hotspotNovo) this.usuarioMenu(usuario, true);

        //Hotspot NAO existe
        if (hotspotNovo) this.copyspot.Usuarios.push(usuario);

    }





    /** MANYHOT **/
    /** ******* **/
    hotspotPush(branded, hotspotID) {

        let object = {etapa: 0, rootile: this.rootile, hotspotID: hotspotID, branded: branded};
        this.navCtrl.push(HotspotMenuPage, object);

    }





    /** ************************************************* SETTING ************************************************* **/
    /** ************************************************* etapa-1 ************************************************* **/

    monitorPush(full) {

        let etapa = (full ? 0 : 2);
        let object = {etapa: etapa, userset: this.userset, hotspotID: this.copyspot.Hotspots[0].HotspotID, workdayID: 0, workdayIZ: 0};
        this.util.modalopen(MonitorDeskPage, 'alto', false, object).subscribe();
    
    }

    hotspotQtde() {

        let onPick = (qtde) => {
            this.copyspot.Hotspots[0].HotspotQtde = qtde;
        };

        let buttons: Array<any> = [];
        for (let i = 0; i < 200; i++) buttons.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = this.copyspot.Hotspots[0].HotspotQtde;
        this.util.pickerOpen(columns, onPick);

    }

    monitorDedo() {

        this.copyspot.Hotspots[0].Setting.SettingDedo = (this.hotspotDedo ? 50 : 0);

    }

    projetoSpot() {

        let onNext = (projeto) => {
            this.copyspot.Hotspots[0].Project = projeto;
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Lorean', handler: () => onNext({ProjetoID: 1005, ProjetoNome: 'Lorean', ProjetoIcon: 'b-icon-cup'})});
        buttons.push({text: 'Férus',  handler: () => onNext({ProjetoID: 1004, ProjetoNome: 'Férus', ProjetoIcon: 'b-icon-gamepad'})});
        this.util.sheetOpen(buttons, 'PROJETO');

    }

    depositMenu() {

        let object = {homeb: false, etapa: 0, title: null, keyname: 'Deposit', toggler: 'ball', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'quad', true, object)
            .subscribe(data => {
                this.copyspot.Hotspots[0].Deposit = this.util.deepCopy(data);
                this.rootspot.Hotspots[0].Deposit = this.util.deepCopy(data);
            });

    }



    dismiss() {

        this.messageService.get('webstor.nick').next('ADM');
        this.navCtrl.pop({animate: false});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/hotspot-menu/hotspot-menu.ts